/* MMM · Le duo (thème, 27/10/2026 — même code que maquette/duo.js, plus l'ajout réel au panier et le suivi de la variante).
   Données : { fiche: produit de la page, duo: produit choisi par Mathilde (champ « Son duo »), varianteFiche: id choisi }.
   Un produit = { handle, title, productType, url, image, options: [{name, values}], variants: [{id, title, price, available, options: [..], image}] }.
   Règles : textes accordés au type des deux bijoux ; même pierre proposée quand elle existe ; une seule valeur = choisie d'office ;
   bouton actif seulement quand le bijou du duo est entièrement choisi ; ajout des deux bijoux en un geste. */
(function () {
  const PIERRES = ['pierre de lune', 'labradorite', 'amazonite', 'cornaline', 'quartz rose', 'amethyste', 'grenat', 'malachite',
    'cristal de roche', 'calcedoine', 'agate', 'larvikite', 'turquoise', 'onyx', 'nacre', 'citrine', 'jade', 'aventurine'];
  const plat = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const ART = { du: 'le', 'de la': 'la', des: 'les' };
  const estTaille = (nom) => /taille|size|longueur/.test(plat(nom));
  const taillee = (u) => (/[?&]width=/.test(u) ? u : u + (u.includes('?') ? '&' : '?') + 'width=500');
  let FORMAT = '{{amount_with_comma_separator}} €';
  const montant = (c, sep, dec) => { const [e, d] = (c / 100).toFixed(dec).split('.'); return e.replace(/\B(?=(\d{3})+(?!\d))/g, sep === ',' ? '.' : ',') + (d ? sep + d : ''); };
  const prix = (c) => FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({ amount: montant(c, '.', 2), amount_no_decimals: montant(c, '.', 0),
    amount_with_comma_separator: montant(c, ',', 2), amount_no_decimals_with_comma_separator: montant(c, ',', 0) }[k] || montant(c, ',', 2)));
  const propre = (v) => { const t = String(v).replace(/(\d)\s*cm/i, '$1 cm').trim(); return t.charAt(0).toUpperCase() + t.slice(1); };

  // Nom du bijou et accords : le titre d'abord (un « Sautoir » est rangé en collier), puis le type.
  function nature(p) {
    const t = plat(p.title + ' ' + p.productType);
    const table = [['boucle', "boucles d'oreilles", 'fp'], ['sautoir', 'sautoir', 'm'], ['collier', 'collier', 'm'], ['bracelet', 'bracelet', 'm'],
      ['bague', 'bague', 'f'], ['broche', 'broche', 'f'], ['sac', 'bijou de sac', 'm']];
    for (const [cle, nom, g] of table) if (plat(p.title).includes(cle)) return { nom, g };
    for (const [cle, nom, g] of table) if (t.includes(cle)) return { nom, g };
    return { nom: 'bijou', g: 'm' };
  }
  function textes(fiche, duo) {
    const f = nature(fiche), d = nature(duo);
    const art = { m: 'Le', f: 'La', fp: 'Les' }[d.g], pron = { m: 'le', f: 'la', fp: 'les' }[f.g];
    const dem = { m: 'ce', f: 'cette', fp: 'ces' }[f.g], verbe = d.g === 'fp' ? 'résonnent' : 'résonne';
    const chacun = f.g !== 'm' && d.g !== 'm' ? 'chacune' : 'chacun';
    const phrase = d.nom === 'bijou' || f.nom === 'bijou'
      ? `Le bijou qui résonne avec celui-ci. À porter ensemble ou ${chacun} à sa façon.`
      : `${art} ${d.nom} qui ${verbe} avec ${dem} ${f.nom}. À porter ensemble ou ${chacun} à sa façon.`;
    return { titre: `Portez-${pron} en duo`, phrase, ficheNom: f.nom, duoNom: d.nom, duoArt: { m: 'du', f: 'de la', fp: 'des' }[d.g], ficheG: f.g };
  }
  // Pierre de la fiche → valeur du duo qui partage une pierre (sinon rien : la cliente choisit).
  function pierreCommune(varianteFiche, valeurs) {
    const v = plat(varianteFiche.options.join(' '));
    const presentes = PIERRES.filter((p) => v.includes(p));
    return valeurs.find((val) => presentes.some((p) => plat(val).includes(p))) || null;
  }

  function rendre(el, data) {
    const { fiche, duo } = data;
    const T = data.textes || textes(fiche, duo);
    if (data.format) FORMAT = data.format;
    let vf = fiche.variants.find((v) => v.id === data.varianteFiche) || fiche.variants.find((v) => v.available) || fiche.variants[0];
    const choix = duo.options.map((o) => (o.values.length === 1 ? o.values[0] : null));

    function caler() {
      duo.options.forEach((o, i) => {
        if (estTaille(o.name) || o.values.length === 1 || el.dataset.touche === String(i)) return;
        const commun = pierreCommune(vf, o.values);
        if (commun) choix[i] = commun;
      });
    }
    const varianteDuo = () => choix.every((c) => c !== null) ? duo.variants.find((v) => v.options.every((x, i) => x === choix[i])) : null;
    const possible = (i, val) => duo.variants.some((v) => v.available && v.options[i] === val && v.options.every((x, j) => j === i || choix[j] === null || x === choix[j]));

    function html() {
      const vd = varianteDuo();
      const imgDuo = (vd && vd.image) || (duo.variants.find((v) => v.options.some((x, i) => x === choix[i] && !estTaille(duo.options[i].name)) && v.image) || {}).image || duo.image;
      const manque = duo.options.filter((o, i) => choix[i] === null).map((o) => (estTaille(o.name) ? 'la taille' : 'la pierre')).sort((a) => (a === 'la pierre' ? -1 : 1));
      // Déjà dans le panier (même variante exacte) : on n'ajoute que ce qui manque, jamais une deuxième fois le même bijou.
      const ficheLa = dansPanier.has(vf.id), duoLa = !!vd && dansPanier.has(vd.id);
      const pret = vd && vd.available && !(ficheLa && duoLa);
      const etiquette = vd && vd.available
        ? (ficheLa && duoLa ? 'Le duo est dans votre panier'
          : ficheLa ? `Ajouter ${ART[T.duoArt] || 'le'} ${T.duoNom} · ${prix(vd.price)}`
          : duoLa ? `Ajouter ${T.ficheG === 'fp' ? 'vos' : 'votre'} ${T.ficheNom} · ${prix(vf.price)}`
          : `Ajouter le duo · 2 bijoux · ${prix(vf.price + vd.price)}`)
        : manque.length ? `Choisissez ${manque.join(' et ')} ${T.duoArt} ${T.duoNom}` : 'Cette combinaison n’est plus disponible';
      const note = message || (pret && ficheLa ? `${T.ficheG === 'fp' ? 'Vos' : 'Votre'} ${T.ficheNom} est déjà dans votre panier.`
        : pret && duoLa ? `${(ART[T.duoArt] || 'le').replace(/^./, (c) => c.toUpperCase())} ${T.duoNom} est déjà dans votre panier.` : '');
      const detailFiche = vf.options.map(propre).join(' · ');
      return `
        <h2 class="mmm-duo__titre">${T.titre}</h2>
        <p class="mmm-duo__phrase">${T.phrase}</p>
        <div class="mmm-duo__paire">
          <figure class="mmm-duo__piece">
            <span class="mmm-duo__image"><img src="${taillee(vf.image || fiche.image)}" alt="" loading="lazy"></span>
            <figcaption class="mmm-duo__legende"><span class="mmm-duo__nom">${T.ficheG === 'fp' ? 'Vos' : 'Votre'} ${T.ficheNom}</span>
              <span class="mmm-duo__detail">${detailFiche}</span><div class="mmm-duo__prix">${prix(vf.price)}</div></figcaption>
          </figure>
          <span class="mmm-duo__plus" aria-hidden="true">+</span>
          <figure class="mmm-duo__piece">
            <a class="mmm-duo__image" href="${duo.url}"><img src="${taillee(imgDuo)}" alt="${duo.title}" loading="lazy"></a>
            <figcaption class="mmm-duo__legende"><a class="mmm-duo__nom" href="${duo.url}">${duo.title}</a>
              <div class="mmm-duo__prix">${prix(vd ? vd.price : Math.min(...duo.variants.map((v) => v.price)))}</div></figcaption>
          </figure>
        </div>
        ${duo.options.map((o, i) => [o, i]).sort((a, b) => estTaille(a[0].name) - estTaille(b[0].name)).map(([o, i]) => o.values.length === 1
          ? `<p class="mmm-duo__choix mmm-duo__seule">${estTaille(o.name) ? 'Taille' : 'Pierre'} : ${propre(o.values[0])}</p>`
          : `<fieldset class="mmm-duo__choix"><legend>${estTaille(o.name) ? `Taille ${T.duoArt} ${T.duoNom}` : 'Pierre'}${choix[i] ? ` : <b>${propre(choix[i])}</b>` : ''}</legend>
              <div class="mmm-duo__options">${o.values.map((val) => `<label class="mmm-duo__option"><input type="radio" name="duo-${el.id}-${i}" value="${val}" data-i="${i}" ${choix[i] === val ? 'checked' : ''} ${possible(i, val) ? '' : 'disabled'}><span>${propre(val)}</span></label>`).join('')}</div>
            </fieldset>`).join('')}
        <button type="button" class="mmm-duo__bouton" ${pret ? '' : 'disabled'}>${etiquette}</button>
        <p class="mmm-duo__retour${erreur ? ' mmm-duo__retour--erreur' : ''}" role="status" aria-live="polite">${note}</p>`;
    }
    let dansPanier = new Set(), message = '', erreur = false;
    function maj() { caler(); el.innerHTML = html(); }
    el.addEventListener('change', (e) => {
      const i = e.target.dataset.i; if (i === undefined) return;
      choix[+i] = e.target.value; if (!estTaille(duo.options[+i].name)) el.dataset.touche = i;
      el.innerHTML = html();
      el.querySelector(`input[data-i="${i}"]:checked`)?.focus();
    });
    el.addEventListener('click', async (e) => {
      const b = e.target.closest('.mmm-duo__bouton'); if (!b || b.disabled) return;
      const vd = varianteDuo();
      b.setAttribute('aria-busy', 'true');
      try {
        if (data.lirePanier) dansPanier = new Set(await data.lirePanier());   // le panier a pu changer ailleurs (autre onglet)
        const items = [vf, vd].filter((v) => !dansPanier.has(v.id)).map((v) => ({ id: v.id, quantity: 1 }));
        message = ''; erreur = false;
        if (items.length && data.ajouter) await data.ajouter(items);
        items.forEach((x) => dansPanier.add(x.id));
        message = 'Le duo est dans votre panier.';
      } catch (err) {
        erreur = true; message = err && err.message && err.message !== 'ajout refusé' ? err.message : 'L’ajout n’a pas marché, réessayez.';
      }
      el.innerHTML = html(); message = ''; erreur = false;
    });
    // La pierre ou la taille changée sur la fiche met le duo à jour.
    el.majFiche = (id) => { const v = fiche.variants.find((x) => x.id === id); if (v) { vf = v; maj(); } };
    el.majPanier = (ids) => { dansPanier = new Set(ids); el.innerHTML = html(); };
    maj();
  }
  // Ajout au panier comme le formulaire du thème (Prestige) : sections du tiroir demandées, puis cart:change ouvre le tiroir.
  async function ajouterAuPanier(items) {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    const racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const r = await fetch(`${racine}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items, sections: sections.join(','), sections_url: `${racine}variants/${items[0].id}` }) });
    const rep = await r.json();
    if (!r.ok) throw new Error(rep.description || rep.message || 'ajout refusé');
    const t = window.themeVariables && themeVariables.settings;
    if (t && (t.cartType === 'page' || t.pageType === 'cart')) { window.location.href = `${racine}cart`; return; }
    const panier = await (await fetch(`${racine}cart.js`)).json();
    panier.sections = rep.sections;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: panier } }));
  }
  async function lirePanier() {
    const racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return (await (await fetch(`${racine}cart.js`)).json()).items.map((i) => i.variant_id);
  }
  function demarrer() {
    document.querySelectorAll('[data-mmm-duo]:not([data-pret])').forEach((el) => {
      const s = el.querySelector('script[type="application/json"]'); if (!s) return;
      let data; try { data = JSON.parse(s.textContent); } catch (e) { return; }
      el.setAttribute('data-pret', '');
      rendre(el, { ...data, ajouter: ajouterAuPanier, lirePanier });
      // Ce qui est déjà dans le panier, tenu à jour : ajout ailleurs sur la page, tiroir modifié, retour arrière dans le navigateur.
      const relire = () => lirePanier().then(el.majPanier).catch(() => {});
      relire();
      document.addEventListener('cart:change', (e) => { const c = e.detail && e.detail.cart; if (c && c.items) el.majPanier(c.items.map((i) => i.variant_id)); else relire(); });
      document.addEventListener('cart:refresh', relire);
      window.addEventListener('pageshow', (e) => { if (e.persisted) relire(); });
      // La variante choisie sur la fiche (pierre, longueur) : le duo suit.
      // (le thème transmet dans detail.formId l'élément « id » du formulaire, pas son nom : on se fie à la variante, ignorée si elle n'est pas de cette fiche)
      document.addEventListener('variant:change', (e) => { if (e.detail && e.detail.variant) el.majFiche(e.detail.variant.id); });
    });
  }
  window.mmmDuo = { rendre, textes, demarrer };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
